let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("10me3")).then(() => parcelRequire('3nx2S'));